import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { COMPANY_TYPES_COLORS, COMPANY_TYPES_MAP } from '../../../../constants';

export const getTableColumns = ({ sorting }) => [
  {
    title: 'Account',
    key: 'organizationName',
    render: ({ organizationId, organizationName, companyType, ownerName }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {organizationName ? (
          <Link
            className="buyer-name"
            to={`/top-buyers/${organizationId}/${encodeURIComponent(
              organizationName,
            )}`}
          >
            {organizationName}
          </Link>
        ) : (
          <span>{ownerName}</span>
        )}
        {companyType && (
          <Tag
            color={COMPANY_TYPES_COLORS[companyType]}
            style={{ marginLeft: '10px' }}
          >
            {COMPANY_TYPES_MAP[companyType]}
          </Tag>
        )}
      </div>
    ),
  },
  {
    title: 'Assets',
    key: 'assets',
    sorter: (a, b) => a.assets - b.assets,
    sortDirections: ['descend', 'ascend'],
    defaultSortOrder: sorting?.columnKey === 'assets' ? sorting.order : null,
    render: ({ assets }) => assets,
  },
  {
    title: 'Mailing address',
    key: 'mailingAddress',
    render: ({ mailingAddress }) => mailingAddress,
  },
];
